import { PopoverPlacement } from "@idui/react-popover";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { DirectionsServiceEnum } from "@ryde/shared";

import { FramerTooltip } from "../tooltips";
import {
  REBUILD_ROUTE_DROPDOWN_TOOLTIP_MOUSE_ENTER_DELAY_MS,
  REBUILD_ROUTE_PROVIDER_INDICATOR_LAST_USED_E2E,
  REBUILD_ROUTE_PROVIDER_LAST_USED_TOOLTIP_OFFSET,
  REBUILD_ROUTE_PROVIDER_SYSTEM_DEFAULT_TOOLTIP_OFFSET,
} from "./rebuild-route-dropdown.constants";
import { RebuildRouteProviderIndicatorsStyled } from "./rebuild-route-provider-indicators.styled";

export interface IRebuildRouteProviderIndicatorsProps {
  providerValue: DirectionsServiceEnum;
  systemDefaultProvider: DirectionsServiceEnum;
  lastUsedProvider?: DirectionsServiceEnum | null;
}

export const RebuildRouteProviderIndicators: FC<
  IRebuildRouteProviderIndicatorsProps
> = ({ providerValue, systemDefaultProvider, lastUsedProvider }) => {
  const { t } = useTranslation();
  const isLastUsed = lastUsedProvider === providerValue;
  const isSystemDefault = systemDefaultProvider === providerValue;

  if (!isLastUsed && !isSystemDefault) {
    return null;
  }

  return (
    <RebuildRouteProviderIndicatorsStyled>
      {isSystemDefault && (
        <FramerTooltip
          content={t("general.SYSTEM_DEFAULT_ROUTE_ENGINE")}
          placement={PopoverPlacement.top}
          offset={REBUILD_ROUTE_PROVIDER_SYSTEM_DEFAULT_TOOLTIP_OFFSET}
          mouseEnterDelay={REBUILD_ROUTE_DROPDOWN_TOOLTIP_MOUSE_ENTER_DELAY_MS}
        >
          <span
            className="rebuild-route-provider-indicator rebuild-route-provider-indicator--system-default"
            data-e2e="rebuild-route-provider-indicator-system-default"
          >
            {t("general.REBUILD_ROUTE_PROVIDER_BADGE_DEFAULT")}
          </span>
        </FramerTooltip>
      )}
      {isLastUsed && (
        <FramerTooltip
          content={t("general.LAST_USED_ROUTE_ENGINE")}
          placement={PopoverPlacement.top}
          offset={REBUILD_ROUTE_PROVIDER_LAST_USED_TOOLTIP_OFFSET}
          mouseEnterDelay={REBUILD_ROUTE_DROPDOWN_TOOLTIP_MOUSE_ENTER_DELAY_MS}
        >
          <span
            className="rebuild-route-provider-indicator rebuild-route-provider-indicator--last-used"
            data-e2e={REBUILD_ROUTE_PROVIDER_INDICATOR_LAST_USED_E2E}
          >
            {t("general.REBUILD_ROUTE_PROVIDER_BADGE_APPLIED")}
          </span>
        </FramerTooltip>
      )}
    </RebuildRouteProviderIndicatorsStyled>
  );
};
